import { render, staticRenderFns } from "./CoinSettings.vue?vue&type=template&id=7c30116a&scoped=true&"
import script from "./CoinSettings.vue?vue&type=script&lang=ts&"
export * from "./CoinSettings.vue?vue&type=script&lang=ts&"
import style0 from "./CoinSettings.vue?vue&type=style&index=0&id=7c30116a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c30116a",
  null
  
)

export default component.exports